import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { GiftCardRequest } from '@/types/OrderSummary';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const giftApi = createApi({
  reducerPath: 'giftApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: `GiftCard` }),
  tagTypes: ['GiftCard'],
  endpoints: builder => ({
    fundGiftCard: builder.mutation<SuccessResponse<unknown>, GiftCardRequest>({
      query: giftCardRequest => ({
        url: '/FundGiftCard',
        method: 'POST',
        body: giftCardRequest,
      }),
      transformResponse: (response: SuccessResponse<unknown>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
      invalidatesTags: ['GiftCard'],
    }),
  }),
});

export const { useFundGiftCardMutation } = giftApi;
